// extracted by mini-css-extract-plugin
export default {"brandPromo":"FK-z","carousel":"GK-z"};